import {get, put} from '@/api/request.js'

const url = '/admin/system/use/model'
/**
 * 获取系统可使用模型
 * @returns {Promise<void>}
 */
export const get_model = async function () {
    return await get(url)
}


/**
 * 修改系统可使用模型
 * @param is_activation{boolean} 是否激活
 * @param id{number} id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const edit_model = async function (is_activation, id) {
    return await put(url, {
        data: {
            is_activation
        },
        params: {
            id
        }
    })
}
